import React from 'react';
import { MemoryRouter, Route } from 'react-router-dom';
import Home from './screens/questao-1.0';
import Questao21 from './screens/questao-2.1';
import Questao22 from './screens/questao-2.2';
import Questao31 from './screens/questao-3.1';
import Questao41 from './screens/questao-4.1';
import Questao42 from './screens/questao-4.2';
import Questao51 from './screens/questao-5.1';
import Questao52 from './screens/questao-5.2';
import Questao61 from './screens/questao-6.1';
import Questao71 from './screens/questao-7.1';
import Questao81 from './screens/questao-8.1';
import Enviada from './screens/enviada';

export default function AppRoutes() {
  return (
    <MemoryRouter>
      <Route exact path="/" component={Home} />
      <Route path="/questao21" component={Questao21} />
      <Route path="/questao22" component={Questao22} />
      <Route path="/questao31" component={Questao31} />
      <Route path="/questao41" component={Questao41} />
      <Route path="/questao42" component={Questao42} />
      <Route path="/questao51" component={Questao51} />
      <Route path="/questao52" component={Questao52} />
      <Route path="/questao61" component={Questao61} />
      <Route path="/questao71" component={Questao71} />
      <Route path="/questao81" component={Questao81} />
      <Route path="/enviada" component={Enviada} />
    </MemoryRouter>
  );
}
